import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13 0H3C1.3 0 0 1.271 0 2.933v15.641c0 .391.2.685.5.88.3.196.7.098 1-.098l6.4-4.496 6.4 4.496c.2.098.4.196.6.196s.3 0 .5-.098c.3-.195.5-.489.5-.88V2.933C16 1.271 14.7 0 13 0m1 16.717-5.4-3.813c-.2-.097-.4-.195-.6-.195s-.4.098-.6.195L2 16.717V2.933c0-.587.4-.978 1-.978h10c.6 0 1 .391 1 .978z"
    }, null, -1)
  ]))]))
}
export default { render: render }